import {isFeatureEnabled} from 'feature-flags';

import {useParams} from 'react-router-dom';

import {useGetSaleVehicleQuery} from '@dms/api/vehicle';
import {featureFlags} from '@dms/feature-flags';
import {useIsQualitySealVisible} from '@dms/shared';

import {useCanReadVehicleAdvertisingSettings} from '../../hooks/useCanReadVehicleAdvertisingSettings';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

interface VehicleSourceSubSectionProps {
  // The host section decides this statically because vehicleVariant is not synced on create.
  showSaleFields?: boolean;
}

export function VehicleSourceSubSection(props: VehicleSourceSubSectionProps) {
  const {id: vehicleId} = useParams();

  const {data: saleVehicle} = useGetSaleVehicleQuery(
    {vehicleId: vehicleId ?? ''},
    {skip: !vehicleId}
  );
  const canReadAdvertisingSettings = useCanReadVehicleAdvertisingSettings(vehicleId);
  const showSaleFields = props.showSaleFields ?? false;
  const isQualitySealVisible = useIsQualitySealVisible();
  const isQualitySealShown = showSaleFields && isQualitySealVisible && canReadAdvertisingSettings;

  return (
    <VFKit.SubSection data-testid="vehicle-source">
      <VFKit.Group data-testid="source-select" columns={[1, 2, 4]}>
        <VFKit.SourceSelect />
        <VFKit.ShowWhen
          when={canReadAdvertisingSettings}
          whenFeatureEnabled={featureFlags.SALES_SALE_PROGRAMS}
        >
          <VFKit.Suspense>
            <VFKit.SalePresetSelect
              isWarrantyShown={showSaleFields && isFeatureEnabled(featureFlags.SALES_WARRANTY)}
              isQualitySealShown={isQualitySealShown}
            />
          </VFKit.Suspense>
        </VFKit.ShowWhen>
        <VFKit.ShowWhen when={isQualitySealShown}>
          <VFKit.Suspense>
            <VFKit.QualitySealSelect selectedQualitySeal={saleVehicle?.qualitySeal} />
          </VFKit.Suspense>
        </VFKit.ShowWhen>
        <VFKit.ShowWhen when={!isQualitySealShown}>
          <VFKit.ShowWhen when={showSaleFields} whenFeatureEnabled={featureFlags.SALES_WARRANTY}>
            <VFKit.Suspense>
              <VFKit.WarrantyProgramSelect />
              <VFKit.WarrantyDurationField />
            </VFKit.Suspense>
          </VFKit.ShowWhen>
        </VFKit.ShowWhen>
      </VFKit.Group>
      <VFKit.ShowWhen
        when={isQualitySealShown && showSaleFields}
        whenFeatureEnabled={featureFlags.SALES_WARRANTY}
      >
        <VFKit.Group data-testid="warranty-fields" columns={[1, 2, 4]}>
          <VFKit.Suspense>
            <VFKit.WarrantyProgramSelect />
            <VFKit.WarrantyDurationField />
          </VFKit.Suspense>
        </VFKit.Group>
      </VFKit.ShowWhen>
    </VFKit.SubSection>
  );
}
